import * as Service from '../services/index';

export default {
  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchStores({ commit }) {
    const response = await Service.getGeospatialStores();
    commit('setProperty', { property: 'stores', payload: response });
    commit('setProperty', { property: 'filter', payload: 'nations' });
    commit('setChartFilter', { country: response.nations[0].address });
  },

  /**
   *
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async fetchProducts({ commit, state }) {
    const response = await Service.getGeospatialProducts(state.chart_filters);
    commit('setProperty', { property: 'products', payload: response });
  },

  /**
   *
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async fetchSales({ commit, state }) {
    const response = await Service.getGeospatialSales(state.line_chart_filters, state.chart_filters);
    commit('setProperty', { property: 'sales', payload: response });
  },

  /**
   *
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async fetchOutletsByState({ commit }, state) {
    const response = await Service.getStoresByState(state);
    commit('setProperty', { property: 'outlets', payload: response });
  },

  async fetchAllCountries({ commit }) {
    const response = await Service.getAllCountries();
    commit('setProperty', { property: 'country', payload: response });
  },
};
